import type { FilterModel } from '../services/ProductsService';

export const useProductStore = defineStore('wk-products', () =>
{
    const columns = reactive<Columns>({
        visible: {},
        positions: {}
    });
    const filter = reactive(Form.create<FilterModel>({
        name: null,
        dateCreatedFromUtc: null,
        dateCreatedDueUtc: null,
        dateModifiedFromUtc: null,
        dateModifiedDueUtc: null,
        authors: null,
        state: null,
        medium: null,
        publicationVersion: null,
        publisher: null,
        categoryId: null
    }));
    const pager = reactive(new Pager(1, 20, 'DateCreatedUtc', 'DESC'));

    return { columns, filter, pager };
});
